import { render, staticRenderFns } from "./Cam.vue?vue&type=template&id=3d3c2668&scoped=true"
import script from "./Cam.vue?vue&type=script&lang=ts"
export * from "./Cam.vue?vue&type=script&lang=ts"
import style0 from "./Cam.vue?vue&type=style&index=0&id=3d3c2668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c2668",
  null
  
)

export default component.exports